import React from "react";
import { getString } from "../../utilities";
import SubscriptionCard from "./subscriptionCard";
import PlanPerks from "./PlanPerks";
import routeCodes from "../../config/routeCodes";
import Arrow from "../../../assets/svg/arrowRight.svg";

export default function SchoolPlans({ plan, planData, activeClick, handleNavigate, className }) {
  return (
    <div className="subscribe-plans-wrapper">
      <div className={`${className} transition-count-1`}>
        <PlanPerks devices={getString("subscribe.plans.perks.devices.school")} />
      </div>

      <div className={`${className} transition-count-2`}>
        <div className="subscribe-plans-container">
          <SubscriptionCard planData={planData} plan={plan} subscription="m12" tabIndex={0} activeClick={activeClick} />
        </div>

        <div className="subscribe-plans-description">{getString("subscribe.plans.description")}</div>

        <div className="subscribe-cta-links-container">
          {getString("subscribe.plans.school.looking")}{" "}
          <button
            data-testid="school-form-back-btn"
            type="button"
            role="button"
            aria-label={getString("subscribe.plans.classroom.go")}
            onClick={() => {
              if (handleNavigate) {
                handleNavigate(routeCodes.SUBSCRIBE_CLASSROOM);
              }
            }}
            className="planbutton button-flat-color pt-cyan round auto"
          >
            {getString("subscribe.plans.school.back")}
            <Arrow className="inline-arrow" />
          </button>
        </div>
      </div>
    </div>
  );
}
